import { useEffect, useState } from "react";

import { getUiHealth } from "../../../services/eroundProvisioning";
import { UiHealth } from "../../../types/eroundProvisioning";

/**
 * eRound screen health, loaded once per mount (SOPS-164): undefined while it
 * loads, null when it could not be loaded. No polling: checks run nightly.
 */
export const useUiHealth = (): UiHealth | null | undefined => {
  const [health, setHealth] = useState<UiHealth | null>();

  useEffect(() => {
    getUiHealth().then(setHealth, () => setHealth(null));
  }, []);

  return health;
};
